var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficeList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#2FC365"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.151 11.2727H14.8486C14.6302 11.2727 14.4502 11.4505 14.4502 11.6711V13.7146H15.2447V12.0672H19.7526V13.7123H20.5471V11.6711C20.5493 11.4528 20.3693 11.2727 20.151 11.2727Z",
    fill: "#515E6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7017 13.8654V23.3652C24.7017 23.5632 24.5396 23.7275 24.3393 23.7275H10.6602C10.4599 23.7275 10.2979 23.5632 10.2979 23.3652V13.8654C10.2979 13.6673 10.4599 13.503 10.6602 13.503H24.3416C24.5396 13.5053 24.7017 13.6673 24.7017 13.8654Z",
    fill: "#B47B52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7017 13.8654V16.7304H10.2979V13.8654C10.2979 13.6673 10.4599 13.503 10.6602 13.503H24.3416C24.5396 13.5053 24.7017 13.6673 24.7017 13.8654Z",
    fill: "#8E5C3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8231 17.5091H16.1764C16.0886 17.5091 16.0144 17.4371 16.0144 17.3471V16.1137C16.0144 16.026 16.0864 15.9517 16.1764 15.9517H18.8231C18.9109 15.9517 18.9851 16.0237 18.9851 16.1137V17.3471C18.9851 17.4371 18.9131 17.5091 18.8231 17.5091Z",
    fill: "#515E6D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0225 5.98877C33.0225 2.68126 30.3412 0 27.0337 0C23.7262 0 21.0449 2.68126 21.0449 5.98877C21.0449 9.29628 23.7262 11.9775 27.0337 11.9775C30.3412 11.9775 33.0225 9.29628 33.0225 5.98877Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0337 1.48877C24.5587 1.48877 22.5337 3.51377 22.5337 5.98877C22.5337 8.46377 24.5587 10.4888 27.0337 10.4888C29.5087 10.4888 31.5337 8.46377 31.5337 5.98877C31.5337 3.51377 29.5087 1.48877 27.0337 1.48877ZM28.9237 5.22377L26.7637 7.38377C26.5837 7.56377 26.3137 7.56377 26.1337 7.38377L25.1437 6.39377C24.9637 6.21377 24.9637 5.94377 25.1437 5.76377C25.3237 5.58377 25.5937 5.58377 25.7737 5.76377L26.4487 6.43877L28.2937 4.59377C28.4737 4.41377 28.7437 4.41377 28.9237 4.59377C29.1037 4.77377 29.1037 5.04377 28.9237 5.22377Z",
    fill: "#2FC365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeList);
export default __webpack_public_path__ + "static/media/OfficeList.869a1139295e287baa7f052cf01dafbb.svg";
export { ForwardRef as ReactComponent };